module.exports = __webpack_public_path__ + "static/img/jiaoshiappbg.a5df3a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiaoshiappbg.png
// module id = AUyH
// module chunks = 10